// extracted by mini-css-extract-plugin
export default {"mainWrapper":"remarks-container_mainWrapper__UOVDb","boxWrapper":"remarks-container_boxWrapper__eHTZf"};